import React from 'react';
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Button } from "@progress/kendo-react-buttons";
import localize from '../../hoc/localize';
import PropTypes from 'prop-types'
import DropDownContainer from '../DropDownContainer';
import { AppContext } from '../../context/AppContext';
import { getMonthsForLast2Years } from '../../helpers'

class DashboardFilters extends React.Component {

    static propTypes = {
        applyDashboardFilters: PropTypes.func
    }

    //constructor(props) {
    //    super(props);
    //    //this.dates = getMonthsForLast2Years('en');
    //}

    handleDateChange = e => {
        this.context.setState({
            selectedFilterDate: e.target.value
        });
        //console.log(e.target.value)
    };

    handleOrgChange = e => {
        this.context.setState({
            selectedFilterOrg: e.target.value,
            selectedFilterVendor: null
        });
    };

    handleVendorChange = e => {
        this.context.setState({
            selectedFilterVendor: e.target.value
        })
    };

    handleOrgGroupChange = e => {
        this.context.setState({
            selectedFilterReportGroup: e.target.value,
            selectedFilterVendor: null
        });
    };

    // user has decided to change the filter type to either report group or dealership
    handleFilterTypeChange = e => {
        this.context.setState({
            selectedFilterType: e.target.value,
            selectedFilterVendor: null
        });
    };

    checkIfRequiredFiltersSpecified = () => {
        const orgType = this.context.state.orgType;

        if (!this.context.state.selectedFilterDate) return false;

        if (orgType === "dealer") {
            return true;
        } else {
            return (
                // if dealership filter type, then must have selected a dealership, OR
                // if reportgroup filter type, then must have selected a report group, OR
                // selected the "view all" filter type
                (this.context.state.selectedFilterType === "dealership" &&
                    this.context.state.selectedFilterOrg) ||
                (this.context.state.selectedFilterType === "reportGroup" &&
                    this.context.state.selectedFilterReportGroup) ||
                this.context.state.selectedFilterType === "viewAll"
            );
        }
    };

    componentDidUpdate = (prevProps) => {
        //console.log(prevProps)
        if (prevProps.uiLanguage !== this.props.uiLanguage) {
            //console.log(this.context.state.selectedFilterDate)
            for (const i in this.dates) {
                //console.log(this.dates[i])
                if (this.dates[i].dateID === this.context.state.selectedFilterDate.dateID) {
                    this.context.setState({
                        selectedFilterDate: this.dates[i],
                    });
                    break;
                }
            }
        }
    }
    
    componentDidMount = () => {
        for (const i in this.dates) {
            //console.log(this.dates[i])
            if (this.dates[i].dateID === this.context.state.selectedFilterDate.dateID) {
                this.context.setState({
                    selectedFilterDate: this.dates[i],
                });
                break;
            }
        }
    }

    //!DBTRANS! @m0005@ Filter by ... !DEVNOTE! Selector title
    //!DBTRANS! @m0007@ Dealership !DEVNOTE! Selector option
    //!DBTRANS! @m0008@ Report Group !DEVNOTE! Selector caption
    //!DBTRANS! @m0009@ View All !DEVNOTE! Selector caption
    //!DBTRANS! @m0017@ Choose a dealership !DEVNOTE! Option Label
    //!DBTRANS! @m0018@ Choose a group !DEVNOTE! Dropdown Label
    //!DBTRANS! @m0019@ Choose a vendor !DEVNOTE! Dropdown Label
    //!DBTRANS! @m0020@ Choose a period !DEVNOTE! Dropdown Label
    //!DBTRANS! @m0021@ Apply !DEVNOTE! Option Label

    render() {
        const { orgType, selectedFilterType, selectedFilterOrg, selectedFilterReportGroup } = this.context.state;

        this.dates = getMonthsForLast2Years(this.props.getLanguage());

        return (
            <AppContext.Consumer>
                {context => (
                    <div className="inventory-selector">
                        {// this is supposed to check for user's orgType/permission level
                            orgType === "dealer" ? (
                                <span />
                            ) : (
                                    <React.Fragment>
                                        <div className="right-margin-30">

                                            <div className="bottom-margin-10" style={{ fontSize: 10.5, paddingTop: 5 }}>
                                                {this.props.returnLocalizedString("m0005")}
                                            </div>

                                            <div className="k-form-field">
                                                <input
                                                    type="radio"
                                                    name="filterType"
                                                    id="dealership"
                                                    value="dealership"
                                                    className="k-radio"
                                                    checked={
                                                        context.state
                                                            .selectedFilterType ===
                                                        "dealership"
                                                    }
                                                    onChange={
                                                        this.handleFilterTypeChange
                                                    }
                                                />

                                                <label
                                                    htmlFor="dealership"
                                                    className="k-radio-label"
                                                >
                                                    {this.props.returnLocalizedString("m0007")}
                                            </label>
                                            </div>

                                            <div className="k-form-field">
                                                <input
                                                    type="radio"
                                                    name="filterType"
                                                    id="reportGroup"
                                                    value="reportGroup"
                                                    className="k-radio"
                                                    checked={
                                                        context.state
                                                            .selectedFilterType ===
                                                        "reportGroup"
                                                    }
                                                    onChange={
                                                        this.handleFilterTypeChange
                                                    }
                                                />

                                                <label
                                                    htmlFor="reportGroup"
                                                    className="k-radio-label"
                                                >
                                                {this.props.returnLocalizedString("m0008")}
                                            </label>
                                            </div>

                                            <div className="k-form-field">
                                                <input
                                                    type="radio"
                                                    name="filterType"
                                                    id="viewAll"
                                                    value="viewAll"
                                                    className="k-radio"
                                                    checked={
                                                        context.state
                                                            .selectedFilterType ===
                                                        "viewAll"
                                                    }
                                                    onChange={
                                                        this.handleFilterTypeChange
                                                    }
                                                />

                                                <label
                                                    htmlFor="viewAll"
                                                    className="k-radio-label"
                                                >
                                                   {this.props.returnLocalizedString("m0009")}
                                            </label>
                                            </div>
                                        </div>

                                        {context.state.selectedFilterType ===
                                            "dealership" && (
                                                <fieldset className="right-margin-20">
                                                    <DropDownList
                                                        data={
                                                            context.state
                                                                .childDealerships
                                                        }
                                                        name="org"
                                                        textField="orgName"
                                                        dataItemKey="orgID"
                                                        label= {this.props.returnLocalizedString("m0017")}
                                                        value={
                                                            context.state
                                                                .selectedFilterOrg
                                                        }
                                                        onChange={
                                                            this.handleOrgChange
                                                        }
                                                        disabled={
                                                            context.state
                                                                .selectedFilterType !==
                                                            "dealership"
                                                        }
                                                    />
                                                </fieldset>
                                            )}

                                        {context.state.selectedFilterType ===
                                            "reportGroup" && (
                                                <fieldset className="right-margin-20">
                                                    <DropDownList
                                                        data={
                                                            context.state
                                                                .reportGroups
                                                        }
                                                        name="reportGroup"
                                                        textField="reportGroupName"
                                                        dataItemKey="reportGroupID"
                                                        label= {this.props.returnLocalizedString("m0018")}
                                                        value={
                                                            context.state
                                                                .selectedFilterReportGroup
                                                        }
                                                        onChange={
                                                            this.handleOrgGroupChange
                                                        }
                                                        disabled={
                                                            context.state
                                                                .selectedFilterType !==
                                                            "reportGroup"
                                                        }
                                                    />
                                                </fieldset>
                                            )}

                                    </React.Fragment>
                                )}

                        <fieldset className="right-margin-20">
                            {/* For the vendors dropdown, pass in either orgID or reportGroupID depending on selection. */}
                            <DropDownContainer
                                id="selectedFilterVendor"
                                name="selectedFilterVendor"
                                value={this.context.state.selectedFilterVendor}
                                dataType="majorVendors"
                                {...((selectedFilterType === 'dealership' && selectedFilterOrg) ? { orgID: selectedFilterOrg.orgID } : undefined)}
                                {...((selectedFilterType === 'reportGroup' && selectedFilterReportGroup) ? { reportGroupID: selectedFilterReportGroup.reportGroupID } : undefined)}
                                {...(selectedFilterType === 'viewAll' && { orgID: null, reportGroupID: null })}
                                handleChange={this.handleVendorChange}
                                uiLanguage={this.props.getLanguage()}
                                label = {this.props.returnLocalizedString("m0019")}
                                defaultToFirstItem={true}
                                style={{ width: 300 }}
                            />
                        </fieldset>

                        <fieldset className="right-margin-20">
                            <DropDownList
                                data={this.dates}
                                textField="date"
                                dataItemKey="dateID"
                                label = {this.props.returnLocalizedString("m0020")}
                                value={
                                    this.context.state
                                        .selectedFilterDate
                                }
                                onChange={this.handleDateChange}
                                style={{ width: 175 }}
                            />
                        </fieldset>

                        <div className="bottom-margin-20">
                            <Button style={{ top: '12px' }}
                                primary={true}
                                disabled={
                                    !this.checkIfRequiredFiltersSpecified()
                                }
                                onClick={this.props.applyDashboardFilters}
                            >
                                {this.props.returnLocalizedString("m0021")}
                        </Button>
                        </div>

                    </div>
                )}
            </AppContext.Consumer>
        );
    }
}

DashboardFilters.contextType = AppContext;
export default localize(DashboardFilters);



// WEBPACK FOOTER //
// ./src/components/DashboardFilters/index.js